module.exports = __webpack_public_path__ + "img/quienessomos.c85b34c7.png";